import * as React from 'react'

import {ImageSkuBlock} from "@components";


export default function imageSkuColumn() {
    return {
        name: 'skuID', label: 'Image Sku',
        options: {
			headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value, { skuName }) => {
            return <ImageSkuBlock
                skuID={value}
                skuName={skuName}
            />}
        }
    }
}